import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SecondMenu from '../../Components/SecondMenu'
import SlideMenu from '../../Components/SlideMenu'
import UserTR from '../../Components/UserTR'
import firebase from '../../firebase'
import Box from '@mui/material/Box';
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import SearchIcon from '@mui/icons-material/Search';
/* eslint-disable */
function sortByDate(a, b) {
    return b["timeStamp"] - a["timeStamp"]
}
function UserData() {
    const [data, setData] = useState([]);
    const [search, setSearch] = useState([]);
    const [searchQuery, setSearchQuery] = useState("")
    useEffect(() => {
        const loadData = () => {
            async function getData() {
                firebase.database().ref('users/').on('value', (snapshot) => {
                    const rawUserData = []
                    var snapVal = snapshot.val();
                    for (let id in snapVal) {
                        rawUserData.push({ ...snapVal[id], id: id })
                    }


                    rawUserData.sort(sortByDate);

                    setData(rawUserData.sort(sortByDate))
                    setSearch(rawUserData.sort(sortByDate))
                })
            }
            getData()
        }
        loadData()
    }, [searchQuery])
    const handleChange = (event) => {
        setSearchQuery(event.target.value)
    }
    const searchFun = () => {
        if (searchQuery !== "") {
            const newData = data.filter((item) => 
                (item?.name?.toLowerCase()?.includes(searchQuery.toLowerCase()) || 
            item?.phone?.includes(searchQuery) || 
            item?.state?.toLowerCase()?.includes(searchQuery.toLowerCase()) || 
            item?.district?.toLowerCase()?.includes(searchQuery.toLowerCase()))
       );
            setSearch(newData);
        } else {
            const newData = data.sort(sortByDate);
            setSearch(newData);
        }
    };
    return (
        <>
            <SlideMenu title="Edit Catrgories" url="/edit-categories" />
            <Box
                sx={{
                    bgcolor: 'background.default',
                    // width: "100%"
                    display: "flex",
                    flex: 1,
                }}
                className="main-display edit-categories"
            >
                <div className="main-child">
                    <SecondMenu title="Manage orders" url="/orders" />
                    <div className="container smart-card">


                        <Typography
                            sx={{ m: 1, color: 'text.primary', }}
                            variant="h4"
                        >
                            All Users
                        </Typography>
                        <Box>
                            <TextField onChange={handleChange} label="Search" sx={{ width: "400px" }} placeholder='Search by Name, Phone Number, state, district and block' />
                            <Button onClick={searchFun} sx={{ height: "56px", marginLeft: 2 }} variant='contained' color="primary">
                                <SearchIcon />
                            </Button>
                        </Box>
                        <Box sx={{ color: 'text.primary', pb: 10, mt: 3, }} className="table-responsive">

                            <TableContainer sx={{ minWidth: 650, backgroundColor: "#111827" }} component={Paper}>
                                <Table aria-label="simple table">
                                    <TableHead sx={{ backgroundColor: "#1f2937" }}>
                                        <TableRow>
                                            <TableCell align="left">
                                                Sr No.
                                            </TableCell>
                                            <TableCell align="left">
                                                Name
                                            </TableCell>
                                            <TableCell align="left">
                                                User Type
                                            </TableCell>
                                            <TableCell align="left">
                                                Phone No
                                            </TableCell>
                                            <TableCell align="left">
                                                Email
                                            </TableCell>
                                            <TableCell align="left">
                                                State
                                            </TableCell>
                                            <TableCell align="left">
                                                District
                                            </TableCell>
                                            <TableCell align='left'>
                                                Date of Registeration
                                            </TableCell>
                                            <TableCell colSpan={2} align='left'>
                                                Operations
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {search.map((item, index) => (
                                            <UserTR key={index} index={index} list={item} />

                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </div>

                </div>

            </Box>
        </>

    )
}

export default UserData
